// TODO 7.15.0-B1 release of @enonic-types/core
// import { toStr } from '@enonic/js-utils/value/toStr';
import type {ComponentProps, PageData} from '@enonic/react-components';
// import type {Region} from '@enonic-types/core';
import {Region} from '@enonic/react-components';
import type {FooterProps} from '../components/Footer';
import {Footer} from '../components/Footer';
import type {HeaderProps} from '../components/Header/Header';
import Header from '../components/Header/Header';
import * as React from 'react';


export interface DefaultPageProps {
	footerProps: FooterProps;
	headerProps: HeaderProps;
}

export const DefaultPage = ({data, meta, common, component}: ComponentProps<PageData>) => {
	const {
		footerProps,
		headerProps,
	} = data as unknown as DefaultPageProps;
	// console.info('DefaultPage headerProps:', toStr(headerProps));
	// console.info('DefaultPage regions:', toStr(regions));
	// console.info('DefaultPage footerProps:', toStr(footerProps));
	return (
		<>
			<div>
				<Header {...headerProps}/>
			</div>
			<Region data={component.regions?.main?.components} meta={meta} common={common} as="main" name="main"/>
			<div>
				<Footer {...footerProps}/>
			</div>
		</>
	);
}
